export interface IBloodPressureData {
  fullName: string;
  phoneNumber: string;
  gender: 'Female' | 'Male' | 'Others';
  ageRange: '18 - 25' | '26 - 35' | '36 - 45' | '46 - 55' | '56 and above';
  diastolic: number;
  systolic: number;
  heartRate: number;
  fileUrl: string;
  hasHistoryOfHBP: boolean;
}

export const defaultBloodPressureData: IBloodPressureData = {
  fullName: '',
  phoneNumber: '',
  gender: 'Female',
  ageRange: '18 - 25',
  diastolic: 0,
  systolic: 0,
  heartRate: 0,
  fileUrl: '',
  hasHistoryOfHBP: false,
};
